import axios from 'axios';

const API_URL = process.env.REACT_APP_WORLDSINGLES_API_URL || 'http://localhost:3000/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/admin/auth/login', credentials),
  changePassword: (data) => api.post('/admin/auth/change-password', data),
};

// User API
export const userAPI = {
  getUsers: (params = {}) => api.get('/admin/users', { params }),
  getUser: (id) => api.get(`/admin/users/${id}`),
  createUser: (data) => api.post('/admin/users', data),
  updateUser: (id, data) => api.put(`/admin/users/${id}`, data),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
};

// Rooms API
export const roomsAPI = {
  getRooms: (params = {}) => api.get('/admin/rooms', { params }),
  getRoom: (id) => api.get(`/admin/rooms/${id}`),
  createRoom: (data) => api.post('/admin/rooms', data),
  updateRoom: (id, data) => api.put(`/admin/rooms/${id}`, data),
  deleteRoom: (id) => api.delete(`/admin/rooms/${id}`),
};

// Dashboard API
export const dashboardAPI = {
  getStatistics: () => api.get('/admin/dashboard'),
};

// Meetings API
export const meetingsAPI = {
  getMeetings: (params = {}) => api.get('/admin/meetings', { params }),
  getMeetingDetails: (meetingId) => api.get(`/admin/meetings/${meetingId}`),
  deleteMeeting: (meetingId) => api.delete(`/admin/meetings/${meetingId}`),
};

export default api; 